<template>
  <el-dialog
    title="薪资设置"
    :visible="salaryDialogType == 'add'"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    @open="initDialog"
    width="80%"
  >
    <p class="input-flex">
      <span>选择公司:</span>
      <el-select
        class="company-select"
        v-model="selectCompany"
        multiple
        placeholder="请选择所属公司"
      >
        <el-option
          v-for="item in companyList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-button class="search-btn" type="primary" @click="getStaffSalaryList"
        >搜 索</el-button
      >
    </p>
    <p class="input-flex">
      <span>报表名称:</span>
      <el-input v-model="salaryData.name"></el-input>
    </p>
    <el-table
      :data="salaryList"
      tooltip-effect="dark"
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" fixed width="55"> </el-table-column>
      <el-table-column prop="staff_real_name" label="姓名"> </el-table-column>
      <el-table-column prop="company_name" label="所属公司"> </el-table-column>
      <el-table-column prop="bank_name" label="银行名称"> </el-table-column>
      <el-table-column prop="bankcard_num" label="银行卡号"> </el-table-column>
      <el-table-column prop="bankcard_info" label="支行"> </el-table-column>
      <el-table-column prop="salary" label="薪资"> </el-table-column>
      <el-table-column label="奖金">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.bonus"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="补贴">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.allowance"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="社保缴纳" prop="social_insurance">
      </el-table-column>
      <el-table-column label="公积金">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.housing_fund"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="个人所得税">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.income_tax"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="请假扣除">
        <template slot-scope="scope">
          <el-input
            size="small"
            v-model="scope.row.deduct_for_leave"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="迟到扣除">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.deduct_for_late"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="额外调整">
        <template slot-scope="scope">
          <el-input size="small" v-model="scope.row.extra"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="实发薪资">
        <template slot-scope="scope">
          {{ getRealSarlay(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="基本工资" width="120">
        <template slot-scope="scope">
          <el-input
            size="small"
            v-model="scope.row.part_a_salary"
            class="font-salary"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="绩效工资" width="120">
        <template slot-scope="scope">
          <span class="font-salary">{{ getparTBSalary(scope.row) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-alert title="除额外调整其余金额项必须是正数" type="warning" show-icon>
    </el-alert>
    <p class="input-flex">
      <span>备注:</span>
      <el-input v-model="salaryData.remark" type="textarea"></el-input>
    </p>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addSalaryReport"
        >生成薪资结算表</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { managerStaffSalaryList, managerAddSalaryReport } from '@/api/manager'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      salaryList: [],
      isLoading: false,
      salaryData: {
        name: '',
        remark: '',
      },
      salarySelectList: [],
      selectCompany: [],
    }
  },
  props: ['salaryDialogType', 'staffId'],
  computed: {
    ...mapGetters(['companyList']),
    // 获取实发薪资
    getRealSarlay(row) {
      return (_row) => {
        return (
          _row.salary * 1 +
          _row.bonus * 1 +
          _row.allowance * 1 -
          _row.social_insurance -
          _row.housing_fund -
          _row.income_tax -
          _row.deduct_for_leave -
          _row.deduct_for_late +
          _row.extra * 1
        ).toFixed(2)
      }
    },
    // 获取实发薪资
    getparTBSalary(row) {
      return (_row) => {
        return (this.getRealSarlay(_row) - _row.part_a_salary).toFixed(2)
      }
    },
  },
  methods: {
    initDialog() {
      this.selectCompany = []
      this.salaryList = []
      this.isLoading = false
      this.salaryData = {
        name: '',
        remark: '',
      }
      this.salarySelectList = []
    },
    closeDialog() {
      this.$emit('update:salaryDialogType', '')
    },
    handleSelectionChange(_val) {
      this.salarySelectList = _val
    },
    // 获取员工薪资列表
    async getStaffSalaryList() {
      let { code, result } = await managerStaffSalaryList({
        company_list: this.selectCompany,
      })
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.salaryList = result.map((item) => {
          let addData = {
            bonus: 0,
            allowance: 0,
            income_tax: 0,
            deduct_for_leave: 0,
            deduct_for_late: 0,
            extra: 0,
          }
          item = { ...item, ...addData }
          return item
        })
      }
    },
    async addSalaryReport() {
      let postData = {
        ...this.salaryData,
        report_data: JSON.stringify([...this.salarySelectList]),
      }
      this.isLoading = true
      let { code, msg } = await managerAddSalaryReport(postData)
      this.isLoading = false
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.$emit('updateSalaryList')
        this.closeDialog()
        this.$message({
          type: 'success',
          message: msg,
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.company-select {
  width: calc(100% - 180px);
}
.font-salary {
  font-size: 16px;
}
/deep/.el-table {
  margin-bottom: 10px;
  font-size: 12px !important;
  td {
    padding: 7px 0;
  }
  .el-input__inner {
    padding: 0 5px;
  }
}
.input-flex {
  margin: 10px 0;
  display: flex;
  align-items: center;
  > span:first-child {
    width: 100px;
  }
  > .el-input {
    flex: 1;
  }
  .search-btn {
    margin-left: 10px;
  }
}
</style>
